import React from 'react';
import { clearSandboxSession, getSandboxUser } from './sandboxApi';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

export default function SandboxBanner({ rolePath }) {
  const navigate = useNavigate();
  const user = getSandboxUser();

  const handleLogout = () => {
    clearSandboxSession();
    navigate(`/sandbox/${rolePath}`);
  };

  return (
    <div
      data-testid="sandbox-banner"
      className="w-full bg-amber-500 text-amber-950 border-b-4 border-amber-700"
    >
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <span className="text-xl" aria-hidden>⚠️</span>
          <div className="leading-tight">
            <div className="font-bold uppercase tracking-wide text-sm sm:text-base">
              Modo Capacitación · Sandbox
            </div>
            <div className="text-xs sm:text-sm opacity-90">
              Los datos de esta sesión son ficticios y NO afectan producción.
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {user && (
            <span
              data-testid="sandbox-user-label"
              className="hidden sm:inline text-xs font-medium bg-amber-200/70 rounded-full px-3 py-1"
            >
              {user.user_type === 'funcionario' ? 'Funcionario' : 'Validador'} ·{' '}
              {user.email}
            </span>
          )}
          <Button
            data-testid="sandbox-logout-btn"
            size="sm"
            variant="outline"
            className="bg-white hover:bg-amber-50 border-amber-700"
            onClick={handleLogout}
          >
            Salir
          </Button>
        </div>
      </div>
    </div>
  );
}
